export default "__VITE_ASSET__c31821f2__"